<template>
    <!-- 메인팝업 -->
    <div class="popup" :class="{ active: main_popup }" v-if="popupCnt > 0">
        <div class="main-popup">
            <h3 class="main-popup--title">
                <img src="@/assets/resource/img/main/main-popup--title--blood_txt.png" alt="">
                <p class="strong">POPUP ZONE</p>
            </h3>
            <div class="main-popup__cont">
                <p class="main-popup__cont--top">팝업 전체 · <span>{{popupCnt}}개</span></p>
                <swiper
                class="main-popup-swiper"
                :modules="modules"
                :slidesPerView="1"
                :speed="600"
                :spaceBetween="40"
                :breakpoints="{
                    720: { slidesPerView: 2 },
                    1312: { slidesPerView: 3 }
                }"
                :navigation="{
                    nextEl: '.main-popup-swiper__button.next',
                    prevEl: '.main-popup-swiper__button.prev'
                }"
                >
                    <swiper-slide class="main-popup__item" v-for="popup in popupList" :key="popup.attachBag.bannerImg[0].attachNo">
                        <a :href="popup.link ? popup.link : 'javascript:;'" :target="popup.target">
                        <img
                            :src="`/displayFile.do?attachNo=${popup.attachBag.bannerImg[0].attachNo}`"
                            :alt="popup.attachBag.bannerImg[0].altValue || '이미지'"
                            v-if="popup.attachBag.bannerImg"
                        />
                        </a>
                    </swiper-slide>
                </swiper>
                <div class="main-popup-swiper__button-wrap">
                    <button class="main-popup-swiper__button prev"></button>
                    <button class="main-popup-swiper__button next"></button>
                </div>
            </div>
            <div class="main-popup__button-wrap">
                <a href="javascript:;" class="main-popup__button02" @click="closePopup" style="background-image:none;">오늘 하루 열지 않기</a>
                <a href="javascript:;" class="main-popup__button" @click.prevent="main_popup_close"></a>
            </div>
        </div>
    </div>

    <div class="container">

        <section class="bc_section01 classon">
            <div class="bc_video">
                <video src="@/assets/resource/video/blood-video.mp4" autoplay muted loop></video>
            </div>
            <div class="bc_section01__text pc-none">
                <h3 class="bc_section01--tit">
                    <sub>이대혈액암병원</sub>
                    난치에서 완치로
                </h3>
                <p class="bc_section01--p">
                    정밀한 개별 맞춤치료와 가족같은 전인적 케어
                </p>
          
                <svg width="392" height="407" viewBox="0 0 392 407" fill="none" xmlns="http://www.w3.org/2000/svg" class="bc_section01--heart">
                    <path 
                        d="M70.1675 323.926H68.9312C95.8825 349.134 128.547 372.261 166.348 392.354L166.354 392.357L183.841 401.595L201.226 392.357C323.725 327.245 392.279 230.276 387.29 133.856C384.272 76.1871 354.406 29.9775 309.738 12.6485L309.732 12.6462C296.363 7.43635 282.813 4.84524 269.402 4.84524C234.114 4.84524 206.493 22.6492 186.685 41.3854L183.758 44.1545L180.834 41.3811C161.088 22.6507 133.468 4.84524 98.1216 4.84524C84.7688 4.84524 71.2174 7.43565 57.7865 12.6483C36.5935 20.8701 18.7329 35.5929 5.49679 50.9559HC" 
                        fill="none" 
                        stroke="#FF8854" 
                        stroke-width="4"
                        stroke-dasharray="1200"
                        stroke-dashoffset="1200"
                        class="animate-path"
                    />
                </svg>
                
            </div>
            <ul class="bc_section01__btn-wrap">
                <li class="bc_section01__btn-item">
                    <router-link to="/kr/doctorList" class="bc_section01--btn">의료진검색</router-link>
                </li>
                <li class="bc_section01__btn-item">
                    <router-link to="/kr/reserve/reserve" class="bc_section01--btn">진료예약</router-link>
                </li>
                <li class="bc_section01__btn-item">
                    <router-link to="/kr/info_disease/list" class="bc_section01--btn">의학정보</router-link>
                </li>
                <li class="bc_section01__btn-item">
                    <router-link to="/kr/centerList" class="bc_section01--btn">센터소개</router-link>
                </li>
            </ul>
            <div class="visual_image--text-wrap">
                <img src="/resource/img/main/visual_image--text.png" class="visual_image--text" alt="">
            </div>
        </section>
        <section class="bc_section02">
            <div class="inner classon">
                <div class="bc_section__title">
                    <h3 class="bc_section__title--tit">
                        <sub>
                            <span>F</span>
                            <span>r</span>
                            <span>o</span>
                            <span>m</span>
                            &nbsp;
                            <span>I</span>
                            <span>n</span>
                            <span>t</span>
                            <span>r</span>
                            <span>a</span>
                            <span>c</span>
                            <span>t</span>
                            <span>a</span>
                            <span>b</span>
                            <span>l</span>
                            <span>e</span>
                            &nbsp;
                            <span>T</span>
                            <span>o</span>
                            &nbsp;
                            <span>C</span>
                            <span>o</span>
                            <span>m</span>
                            <span>p</span>
                            <span>l</span>
                            <span>e</span>
                            <span>t</span>
                            <span>e</span> 
                            &nbsp;
                            <span>C</span>
                            <span>u</span>
                            <span>r</span>
                            <span>e</span>
                        </sub>
                        <span>이</span>
                        <span>대</span>
                        <span>혈</span>
                        <span>액</span>
                        <span>암</span>
                        <span>병</span>
                        <span>원</span>
                        &nbsp;
                        <span>의</span>
                        <span>료</span>
                        <span>진</span>
                        &nbsp;
                        <span>소</span>
                        <span>개</span>
                    </h3>
                </div>

                <!-- 720 이하부터 나오는 모바일 스와이프 -->
                <div class="bc_section02__list-swiper" v-if="bc_section02_mo">
                    <swiper class="bc_section02__list"
                            :slidesPerView="1.7"
                            :slidesPerGroup="1"
                            :loop="true"
                            :spaceBetween="24"
                            :centeredSlides="true"
                            :modules="modules"
                            :pagination="paginationConfig"
                            :navigation="{
                                nextEl: '.bc_section02--swiper-arrow.next',
                                prevEl: '.bc_section02--swiper-arrow.prev'
                            }"
                        
                        >
                        <swiper-slide class="bc_section02__item" v-for="doctor in doctorList" :key="doctor">
                            <div class="bc_section02__item-wrap">
                                <div class="bc_section02__item__img-box">
                                    <img class="bc_section02__item--img" :src="`/displayFile.do?attachNo=${ doctor.attachBag.thumbs[0].attachNo }`" :alt="doctor.attachBag.thumbs[0].altValue || '이미지'" v-if="doctor?.attachBag?.thumbs">
                                    <div class="bc_section02__hover">
                                        <h4 class="bc_section02__item--tit">{{doctor.name}} 교수</h4>
                                        <p class="bc_section02__item--text">{{doctor.mainDeptNm}}{{doctor.position ? ` / ${doctor.position}` : ''}}</p>
                                        <div class="bc_section02__hover__btn-wrap">
                                            <a class="bc_section02__hover--btn" href="javascript:;" @click="quickReservation(doctor)">빠른예약</a>
                                            <a class="bc_section02__hover--btn" :href="`/kr/doctorInfo?drSid=${doctor.drSid}&deptCd=${doctor.deptCd ? doctor.deptCd : doctor.mainDeptCd}`" target="_blank" >의료진 소개</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                    <button class="bc_section02--swiper-arrow next"></button>
                    <button class="bc_section02--swiper-arrow prev"></button>
                </div>
                <div v-else>
                    <ul class="bc_section02__list" v-if="doctorList.length < 4">
                        <li class="bc_section02__item" v-for="doctor in doctorList" :key="doctor">
                            <div class="bc_section02__item-wrap">
                                <div class="bc_section02__item__img-box">
                                    <img class="bc_section02__item--img" :src="`/displayFile.do?attachNo=${ doctor.attachBag.thumbs[0].attachNo }`" :alt="doctor.attachBag.thumbs[0].altValue || '이미지'" v-if="doctor?.attachBag?.thumbs">
                                    <div class="bc_section02__hover">
                                        <h4 class="bc_section02__item--tit">{{doctor.name}} 교수</h4>
                                        <p class="bc_section02__item--text">{{doctor.mainDeptNm}}{{doctor.position ? ` / ${doctor.position}` : ''}}</p>
                                        <div class="bc_section02__hover__btn-wrap">
                                            <a class="bc_section02__hover--btn" href="javascript:;" @click="quickReservation(doctor)">빠른예약</a>
                                            <a class="bc_section02__hover--btn" :href="`/kr/doctorInfo?drSid=${doctor.drSid}&deptCd=${doctor.deptCd ? doctor.deptCd : doctor.mainDeptCd}`" target="_blank" >의료진 소개</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="bc_section02__list-rows" v-else>
                        <!-- 위쪽 줄: ceil(n/2) -->
                        <ul class="bc_section02__list row-1">
                            <li
                                class="bc_section02__item"
                                v-for="doctor in doctorList.slice(0, Math.ceil(doctorList.length / 2))"
                                :key="doctor.drSid"
                            >
                                <div class="bc_section02__item-wrap">
                                    <div class="bc_section02__item__img-box">
                                        <img
                                            class="bc_section02__item--img"
                                            :src="`/displayFile.do?attachNo=${ doctor.attachBag.thumbs[0].attachNo }`"
                                            :alt="doctor.attachBag.thumbs[0].altValue || '이미지'"
                                            v-if="doctor?.attachBag?.thumbs?.length"
                                        >
                                        <div class="bc_section02__hover">
                                            <h4 class="bc_section02__item--tit">{{doctor.name}} 교수</h4>
                                            <p class="bc_section02__item--text">
                                                {{doctor.mainDeptNm}}{{doctor.position ? ` / ${doctor.position}` : ''}}
                                            </p>
                                            <div class="bc_section02__hover__btn-wrap">
                                                <a class="bc_section02__hover--btn" href="javascript:;" @click="quickReservation(doctor)">빠른예약</a>
                                                <a class="bc_section02__hover--btn"
                                                :href="`/kr/doctorInfo?drSid=${doctor.drSid}&deptCd=${doctor.deptCd ? doctor.deptCd : doctor.mainDeptCd}`"
                                                target="_blank">
                                                    의료진 소개
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>

                        <!-- 아래쪽 줄: 나머지 floor(n/2) -->
                        <ul class="bc_section02__list row-2">
                            <li
                                class="bc_section02__item"
                                v-for="doctor in doctorList.slice(Math.ceil(doctorList.length / 2))"
                                :key="doctor.drSid"
                            >
                                <div class="bc_section02__item-wrap">
                                    <div class="bc_section02__item__img-box">
                                        <img
                                        class="bc_section02__item--img"
                                        :src="`/displayFile.do?attachNo=${ doctor.attachBag.thumbs[0].attachNo }`"
                                        :alt="doctor.attachBag.thumbs[0].altValue || '이미지'"
                                        v-if="doctor?.attachBag?.thumbs?.length"
                                        >
                                        <div class="bc_section02__hover">
                                        <h4 class="bc_section02__item--tit">{{doctor.name}} 교수</h4>
                                        <p class="bc_section02__item--text">
                                            {{doctor.mainDeptNm}}{{doctor.position ? ` / ${doctor.position}` : ''}}
                                        </p>
                                        <div class="bc_section02__hover__btn-wrap">
                                            <a class="bc_section02__hover--btn" href="javascript:;" @click="quickReservation(doctor)">빠른예약</a>
                                            <a class="bc_section02__hover--btn"
                                            :href="`/kr/doctorInfo?drSid=${doctor.drSid}&deptCd=${doctor.deptCd ? doctor.deptCd : doctor.mainDeptCd}`"
                                            target="_blank">
                                            의료진 소개
                                            </a>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <section class="bc_section03">
            <div class="bc_section03__text-bg classon">
                <div class="bc_section03__text-bg01">
                    <img src="/resource/img/main/bc_section03-text-bg01.png" alt="">
                    <img src="/resource/img/main/bc_section03-text-bg01.png" alt="">
                </div>
                <div class="bc_section03__text-bg02">
                    <img src="/resource/img/main/bc_section03-text-bg02.png" alt="">
                    <img src="/resource/img/main/bc_section03-text-bg02.png" alt="">
                </div>
            </div>
            <div class="inner classon">
                <div class="bc_section03--bg-text">

                </div>
                <ul class="bc_section03__list classon">
                    <li class="bc_section03__item">
                        <h3 class="bc_section__title--tit classon">
                            <span class="font-poppins">Why?</span>
                            <strong>
                                <b class="main-bg">
                                    <span>이</span>
                                    <span>대</span>
                                    <span>혈</span>
                                    <span>액</span>
                                    <span>암</span>
                                    <span>병</span>
                                    <span>원</span>
                                </b>
                                <div style="display: flex;justify-content: end;">
                                    <span>인</span>
                                    <span>가</span>
                                </div>
                            </strong>
                        </h3>
                    </li>
                    <li class="bc_section03__item classon" @click="goIntro('intro01')" style="cursor: pointer;">
                        <div class="bc_section03__item--img">
                            <img src="/resource/img/main/bc_section03__item01.png" alt="">
                            <h4 class="bc_section03__item--tit">
                                충분한 혈액분야 전문의 확보 <br>
                                및 혈액암 분야별 센터 운영
                            </h4>
                        </div>
                    </li>
                    <li class="bc_section03__item classon" @click="goIntro('intro02')" style="cursor: pointer;">
                        <div class="bc_section03__item--img">
                            <img src="/resource/img/main/bc_section03__item02.png" alt="">
                            <h4 class="bc_section03__item--tit">
                                24시간 혈액암 <br>
                                전문의의 환자관리
                            </h4>
                        </div>
                    </li>
                    <li class="bc_section03__item classon" @click="goIntro('intro03')" style="cursor: pointer;">
                        <div class="bc_section03__item--img">
                            <img src="/resource/img/main/bc_section03__item03.png" alt="">
                            <h4 class="bc_section03__item--tit">
                                타 기관과는 차별화되는 <br>
                                전문분야별 센터 운영
                            </h4>
                        </div>
                    </li>
                    <li class="bc_section03__item classon" @click="goIntro('intro04')" style="cursor: pointer;">
                        <div class="bc_section03__item--img">
                            <img src="/resource/img/main/bc_section03__item04.png" alt="">
                            <h4 class="bc_section03__item--tit">
                                국내 최초 <br>
                                혈액암 가족돌봄센터
                            </h4>
                        </div>
                    </li>
                    <li class="bc_section03__item">
                        <h3 class="bc_section__title--tit classon">
                            <div style="display: flex;">
                                <span class="c-main30">이</span>
                                <span class="c-main30">대</span>
                                <span class="c-main30">혈</span>
                                <span class="c-main30">액</span>
                                <span class="c-main30">암</span>
                                <span class="c-main30">병</span>
                                <span class="c-main30">원</span>
                                <span class="c-main30">은</span>
                            </div>
                            <strong>
                                <span>이</span>
                                <span>렇</span>
                                <span>게</span>
                                &nbsp;
                                <span>다</span>
                                <span>릅</span>
                                <span>니</span>
                                <span>다.</span>
                            </strong>
                        </h3>
                    </li>
                </ul>
            </div>
        </section>
        <section class="bc_section04">
            <div class="bc_section04--inner">
                <div class="inner classon">
                    <div class="bc_section__title">
                        <h3 class="bc_section__title--tit classon">
                            <span>고</span>
                            <span>맙</span>
                            <span>습</span>
                            <span>니</span>
                            <span>다</span>
                        </h3>
                        <div class="bc_section04--swiper__btn-wrap">
                            <button class="bc_section04--swiper--prev"></button>
                            <button class="bc_section04--swiper--next"></button>
                            <router-link to="/kr/thanks/list" class="bc_section--btn">MORE</router-link>
                        </div>
                    </div>
                    <div class="bc_section04--swiper-wrap">
                        <swiper class="bc_section04--swiper"
                            :slidesPerView="1"
                            :grid="{
                                rows: 2,
                            }"
                            :spaceBetween="24"
                            :modules="modules"
                            :navigation="{
                                nextEl: '.bc_section04--swiper--next',
                                prevEl: '.bc_section04--swiper--prev'
                            }"
                            :breakpoints="{
                                721: {
                                    slidesPerView: 2,
                                    spaceBetween: 40,
                                    grid: {
                                        rows: 1,
                                    }
                                },
                                1025: {
                                    slidesPerView: 3,
                                    grid: {
                                        rows: 1,
                                    }
                                },
                                1281: {
                                    slidesPerView: 4,
                                    grid: {
                                        rows: 1,
                                    }
                                },
                                
                            }"
                        >
                            <swiper-slide class="bc_section04--swiper__item" v-for="(item, index) in thanksList" :key="index">
                                <router-link :to="`/${$store.getters.getLang}/${item.boardId}/view?boardNo=${item.boardNo}&articleNo=${item.articleNo}`">
                                    <div class="bc_section04--swiper__top">
                                        <h3 class="bc_section04--swiper--tit">
                                            {{item.title}}
                                        </h3>
                                        <p class="bc_section04--swiper--p">
                                            {{$commonUtils.removeTags(item.content)}}
                                        </p>
                                    </div>
                                    <div class="bc_section04--swiper__bottom" v-if="thanksPeoples(item)">
                                        <p class="bc_section04--swiper--p" v-html="thanksPeoples(item)">
                                        </p>
                                    </div>
                                    <img class="bc_section04--swiper--img" :src="`/displayFile.do?drSid=${ item.refDoctorList[0].drSid }`" alt="이미지" v-if="item.refDoctorList?.length" onerror="this.style.display='none'">
                                </router-link>
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>
                <img class="bc_section04--bg01" src="/resource/img/main/bc_section04--bg01.png" alt="">
                <img class="bc_section04--bg02" src="/resource/img/main/bc_section04--bg02.png" alt="">
                <img class="bc_section04--bg03" src="/resource/img/main/bc_section04--text-bg.png" alt="">
                <img >
            </div>
        </section>
        <section class="bc_section05 classon">
            <div class="inner">
                <div class="bc_section__title">
                    <h3 class="bc_section__title--tit classon">
                        <sub>
                            <span>B</span>
                            <span>L</span>
                            <span>O</span>
                            <span>O</span>
                            <span>D</span>
                            &nbsp;
                            <span>H</span>
                            <span>E</span>
                            <span>A</span>
                            <span>L</span>
                            <span>T</span>
                            <span>H</span>
                            &nbsp;
                            <span>T</span>
                            <span>V</span>
                        </sub>
                        <span>혈</span>
                        <span>액</span>
                        <span>건</span>
                        <span>강</span>
                        <span style="margin-left: 0.2em;">T</span>
                        <span>V</span>
                    </h3>
                    <router-link :to="'/kr/wellness_tv/list'" class="bc_section--btn">MORE</router-link>
                </div>
                <swiper
                    :thumbs="{ swiper: thumbsSwiper }"
                    :modules="modules"
                    :effect="'fade'"
                    :allow-touch-move="false"
                    class="bc_section05--swiper"
                >
                    <swiper-slide v-for="tv in tvList" :key="tv.articleNo" @click="goArticle(tv)" style="cursor: pointer;">
                        <div class="video">
                            <iframe style="width:100%; height: 100%;" :src="`https://www.youtube.com/embed/${$commonUtils.getYoutubeId(tv)}`" title="YouTube video player" frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen v-if="tv.linkUrl"></iframe>
                        </div>
                        <!-- <img class="video" :src="`https://img.youtube.com/vi/${$commonUtils.getYoutubeId(tv)}/mqdefault.jpg`" alt="이미지" v-if="tv.linkUrl && tv.linkUrl.indexOf('youtu') > -1">
                        <img class="video" :src="`/displayFile.do?attachNo=${tv.attachBag.thumbs[0].attachNo}`" :alt="tv.attachBag.thumbs[0].altValue || '이미지'" v-else-if="tv.attachBag.thumbs" /> -->
                        <h4 class="bc_section05--swiper--tit">{{tv.title}}</h4>
                    </swiper-slide>
                </swiper>
            </div>
            <swiper
                @swiper="setThumbsSwiper"
                :direction="'horizontal'"
                :slidesPerView="4"
                :freeMode="true"
                :watchSlidesProgress="true"
                :modules="modules"
                :breakpoints="{
                    1451: {
                        direction: 'vertical', 
                    },
                    
                }"
                class="bc_section05--sub-swiper"
            >
                <swiper-slide v-for="tv in tvList" :key="tv.articleNo">
                    <button>
                        <img class="video" :src="`https://img.youtube.com/vi/${$commonUtils.getYoutubeId(tv)}/mqdefault.jpg`" alt="이미지" v-if="tv.linkUrl && tv.linkUrl.indexOf('youtu') > -1">
                        <!-- <img class="video" :src="`/displayFile.do?attachNo=${tv.attachBag.thumbs[0].attachNo}`" :alt="tv.attachBag.thumbs[0].altValue || '이미지'" v-if="tv.attachBag.thumbs" /> -->
                    </button>
                </swiper-slide>
            </swiper>
        </section>
        <section class="bc_section06">
            <div class="inner classon">
                <div class="bc_section__title">
                    <h3 class="bc_section__title--tit classon">
                        <!-- <sub>
                            <span>B</span>
                            <span>L</span>
                            <span>O</span>
                            <span>O</span>
                            <span>D</span>
                            &nbsp;
                            <span>C</span>
                            <span>A</span>
                            <span>N</span>
                            <span>C</span>
                            <span>E</span>
                            <span>R</span>
                            &nbsp;
                            <span>H</span>
                            <span>O</span>
                            <span>S</span>
                            <span>P</span>
                            <span>I</span>
                            <span>T</span>
                            <span>A</span>
                            <span>L</span>
                            &nbsp;
                            <span>N</span>
                            <span>E</span>
                            <span>W</span>
                            <span>S</span>
                        </sub> -->
                        <span>이</span>
                        <span>대</span>
                        <span>혈</span>
                        <span>액</span>
                        <span>암</span>
                        <span>병</span>
                        <span>원</span>
                        &nbsp;
                        <span>소</span>
                        <span>식</span>
                    </h3>
                    <router-link :to="`/kr/${viewBoardName.indexOf('news') > -1 ? 'bld_news' : 'bld_notice'}/list`" class="bc_section--btn">MORE</router-link>
                </div>
                <div class="bc_section06__btn-wrap">
                    <button :class="{'bc_section06--btn': true, 'on': viewBoardName == 'all'}" @click="showList('all')">전체보기</button>
                    <button :class="{'bc_section06--btn': true, 'on': viewBoardName == 'news'}" @click="showList('news')">언론보도</button>
                    <button :class="{'bc_section06--btn': true, 'on': viewBoardName == 'notice'}" @click="showList('notice')">공지사항</button>
                </div>
                <div class="bc_section06__board-wrap">
                    <ul class="bc_section06__board">
                        <li class="bc_section06__board__item" v-for="i in viewList" :key="i.articleNo">
                            <component :is="i.boardId.indexOf('news') > -1 ? 'a' : 'router-link'" :href="i.linkUrl" :to="`/${$store.getters.getLang}/${i.boardId}/view?boardNo=${i.boardNo}&articleNo=${i.articleNo}`" :target="i.boardId.indexOf('news') > -1 ? '_blank' : '_self'" class="bc_section06__board--link">
                                <div class="bc_section06__board__con">
                                    <span class="bc_section06__board--day">
                                        {{dateNumToStr(i.createdDt, '.').date}}
                                        <sub>{{dateNumToStr(i.createdDt, '.').yearmonth}}</sub>
                                    </span>
                                    <span class="bc_section06__board--tag" :class="i.boardId.indexOf('notice') > -1 ? 'type02' : 'type01'">
                                        {{i.boardId.indexOf('notice') > -1 ? '공지사항' : '언론보도'}}
                                    </span>
                                    <span class="bc_section06__board--tit">
                                        {{i.title}}
                                    </span>
                                </div>
                            </component>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        <goTop />
    </div>
    
    <kr_FirstReservePopUp :popupVisible="firstVisible" :name="name" :tel="tel" @hide-popup="hidePopup" />
    <kr_AlarmTalkPopup :popupVisible="alarmVisible" :name="name" :tel="tel" @hide-popup="hidePopup" />
</template>

<script>
    import { ref } from 'vue';
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import 'swiper/css';
    import 'swiper/css/pagination';
    import 'swiper/css/thumbs';
    import 'swiper/css/grid';
    import { Pagination, Navigation, Thumbs, FreeMode, EffectFade, Grid } from 'swiper/modules';
    import goTop from '@/components/kr/common/GoTop.vue';

    export default {
        components: {
            Swiper,
            SwiperSlide,
            goTop,
        },
        setup() {
            const thumbsSwiper = ref(null);
            const setThumbsSwiper = (swiper) => {
                thumbsSwiper.value = swiper;
            };
            return {
                thumbsSwiper,
                setThumbsSwiper,
                modules: [Pagination, Navigation, Thumbs, FreeMode, EffectFade, Grid],
            };
        },
        data() {
            return {
                paginationConfig: {
                    type: 'custom',
                    renderCustom: (swiper, current, total) => {
                        // 두 자릿수 형식으로 포맷팅
                        const formattedCurrent = current.toString().padStart(2, '0');
                        const formattedTotal = total.toString().padStart(2, '0');
                        return `<span>${formattedCurrent}</span> / <span>${formattedTotal}</span>`;
                    },
                    clickable: true
                },
                main_popup: true,
                doctorList: [],
                thanksList: [],
                tvList: [],
                allList: [],
                newsList: [],
                noticeList: [],
                viewBoardName: 'all',
                viewList: [],
                drSids: '1019616,1001808,1001705,1002748,1015451,1024351,1022642,1005698',
                bc_section02_mo: false,
            };
        },
        methods: {
            goArticle(article){
                const url = `/${this.$store.getters.getLang}/${article.boardId}/view?boardNo=${article.boardNo}&articleNo=${article.articleNo}`
                window.open(url, '_blank')
            },
            goIntro(id){
                const url = '/kr/intro/intro#' + id
                console.log(url)
                location.href = url
            },
            dateNumToStr(num,dot){
                const year = new Date(num).getFullYear();
                const month = new Date(num).getMonth() + 1;
                const date = new Date(num).getDate();
                return {
                    'yearmonth': `${year}${dot}${month >= 10 ? month : '0' + month}`,
                    'date': `${date >= 10 ? date : '0' + date}`
                }
            },
            showList(board){
                this.viewBoardName = board
                this.viewList = this[board + 'List']
            },
            getMainBoardList() {
                const param = {
                    pageRow: 5
                }
                this.axios.get(this.api.article.main, {
                    params: param
                })
                    .then(res => {
                        const list = res.data
                        this.tvList = list['tv']
                        if(this.tvList?.length > 4){
                            this.tvList.length = 4
                        }
                        this.allList = list['all']
                        this.newsList = list['news']
                        this.noticeList = list['notice']
                        this.viewList = this.allList
                    })
            },
            hidePopup(param) {
                this[param] = false;
            },
            getMainBanner() {
                const param = {
                    hospId: this.$store.getters.getHost
                }
                this.axios.get(this.api.banner.main, {
                    params: param
                }).then(res => {
                    // 팝업
                    const popup = res.data.popup
                    this.popupCnt = popup.totCnt
                    this.popupList = popup.list

                    if(this.popupCnt > 0){
                        this.main_popup = true

                        const oneDay = 24 * 60 * 60 * 1000
                        const now = new Date().getTime()

                        const popupLastVisit = localStorage.getItem('popupTime_blood')
                        const popupLastVisitTime = popupLastVisit ? parseInt(popupLastVisit, 10) : null
                        const popupTimeSinceLastVisit = popupLastVisitTime ? now - popupLastVisitTime : null

                        if (popupLastVisitTime && popupTimeSinceLastVisit < oneDay) {
                            this.main_popup = false;
                        }
                    }else{
                        this.main_popup = false
                    }
                })
            },
            closePopup() {
                this.main_popup = false;
                const now = new Date().getTime()
                localStorage.setItem('popupTime_blood', now.toString())
            },
            main_popup_close() {
                this.main_popup = false;
            },
            initIntersectionObserver() {
                const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    const target = entry.target;
                    if (entry.isIntersecting) {
                        target.classList.add('on');
                    }else{
                        // target.classList.remove('on');
                    }
                });
                }, {
                threshold: 0.3 // 요소가 30% 이상 보일 때
                });

                // 클래스 선택자 사용
                const elementsToObserve = document.querySelectorAll('.classon');
                
                elementsToObserve.forEach((element) => {
                observer.observe(element);
                });
            },
            getDoctorList(){
                const param = {
                    startIndex: 1,
                    pageRow: 100,
                    langCd: this.$store.getters.getLang,
                    hospId: this.$store.getters.getHost,
                    drSids: this.drSids
                }
                console.log(this.param)
                this.axios.get(this.api.doctor.doctorList, {params: param})
                .then(res => {
                    this.doctorList = res.data.doctorList
                    const drSidsArr = this.drSids.split(',')
                    console.log("doctor data: " + this.doctorList);
                    console.log(this.doctorList);
                    console.log("list check: " + Array.isArray(this.doctorList));
                    if(Array.isArray(this.doctorList)){
                        this.doctorList.sort((a, b) => {
                            return drSidsArr.indexOf(a.drSid) - drSidsArr.indexOf(b.drSid)
                        })
                    }

                    this.bc_section02_mo = window.innerWidth <= 720;
                    // this.doctorList = this.$commonUtils.distinctList(arr, 'name')
                })
            },
            quickReservation(doctor) {
                this.$store.state.reserveStore.quickReserve = doctor
                this.$router.push('/kr/reserve/reservation')
            },
            getThanksList() {
                const boardNo = 10
                const params = {
                    hospId: this.$store.getters.getHost,
                    boardNo: boardNo,
                    startIndex: 1,
                    pageRow: 10,
                    title: '',
                    content: '',
                    searchKeyword: '',
                    item18: 'O'
                }
                this.axios.get(this.api.article.list + boardNo, {
                    params: params
                })
                    .then(res => {
                        this.thanksList = res.data.list
                    })
            },
            thanksPeoples(article) {
                let result = article.item1
                let doctorNames = []

                if (article.refDoctorList) {
                    for (let i of article.refDoctorList) {
                        doctorNames.push(`${i.deptNm}<br>${i.drName}`)
                    }
                }
                if (doctorNames.length > 0) {
                    if (result) {
                        result = "<span>" + result + "</span><br>" + doctorNames.join("<br>");
                    } else {
                        result = doctorNames.join('<br>');
                    }
                }

                return result
            },
        },
        mounted() {
            this.initIntersectionObserver();
            this.getMainBanner()
            this.getDoctorList()
            this.getMainBoardList()
            this.getThanksList()
        },
        beforeUnmount() {
          
        },
    }
</script>